import {client} from "helpers/client";


export interface Version {
    // title(title: any): import("react-i18next").ReactI18NextChild | Iterable<import("react-i18next").ReactI18NextChild>;
    id: string;
    name: string,
    title:string,
    shortDescription: string,
    logo:{fullPath:string},
    downloadUrl: string,
    releaseNumber:string;
    lastUpdatedOn : string | null
}

export interface App {
    id: string,
    title: string,
    logo: { fullPath: string },
    versions: Version[],
    rate :{ averageRate:number,count:number}
}

export class DownloadCenterService {
    static getAllApps() {
        return client<App[]>('/downloadCenter/getAll')
    }

    static getFilteredApps(query: string) {
        return client<{ items: App[] }>('/downloadCenter/getPagedList', {
            params: {
                skipCount: 0,
                searchTerm: query,
                maxResultCount: 5000
            }
        })
    }
}